/*jshint expr:true */
define('views/RedhookView',[
    'backbone',
    'lodash',
    'text!templates/redhook.html',
    'app'
], function (Backbone, _, redhookTmpl, App) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        initialize: function () {
            // projects under redhook
            var featured = _.filter(App.projects, {featured: 1});
            this.projects = _.reject(featured, {title: 'Red Hook'});
        },

        render: function () {
            this.$el.html(this.template(App));
        },

        template: _.template(redhookTmpl)

    });

});
